export const helpText =  [
    {
        header: 'THE BASICS',
        text: [
            `The player (you) controls the pokemon on the left.  You have 4 random moves to choose from.`, 
            `Hovering over the move will show you additional information.`,
            `Click on the move you want to use, then press the FIGHT button to see the results of the battle!`
        ]
    },
    {
        header:'THE POKEMON',
        text: [
            `Each pokemon has different stats, shown next to their picture. Higher stats give a pokemon an edge in battle, but they don't guarantee victory!`,
            `HP: The HIT POINTS of a pokemon. Reduced by opponent's ATTACKS. Once a pokemon's HIT POINTS reach 0, they die.`,
            `SPEED: How fast a pokemon is. The Pokemon with the higher SPEED is more likely to act first.`,
            `CRITICAL CHANCE: When a pokemon uses an ATTACK, there is a chance it is a CRITICAL HIT. It DOUBLES the DAMAGE dealt to the opponent's HIT POINTS.`
        ]
    },
    {
        header:`THE MOVES`,
        text: [
            `Every move belongs to one of two categories: it is either an ATTACK or a SPECIAL MOVE.`, 
            `ATTACKS deal damage directly to a pokemon. If they hit, they reduce the opponent's HIT POINTS.`,
            `SPECIAL MOVES don't deal any damage, but affect the STATS of a pokemon. Some weaken the opponent's STATS, others boost your own.`,
            `ACCURACY: This is the percentage chance that your chosen MOVE will succeed. Most SPECIAL MOVES have an accuracy of 100, whereas ATTACKS are more likely to miss.`,
            `POWER/EFFECT: If a MOVE is an ATTACK, it will have a POWER stat. This is how many HIT POINTS it will take from the opponent if it hits. If the ATTACK is a CRITICAL HIT, the POWER is doubled (for one round only).`,
            `If a MOVE is a SPECIAL MOVE, it will have an EFFECT. How each EFFECT works is detailed below. SPECIAL MOVES always have a POWER of 0, and are not affected by CRITICAL HITS.`,
        ]
    },
    {
        header:`THE BATTLE REPORT`,
        text: [
            ``
        ]
    },
    {
        header:`WHO GOES FIRST?`,
        text: [
            ``
        ]
    },
    {
        header:`CONTINUING THE FIGHT`,
        text: [
            ``
        ]
    },
    {
        header:`WINNING`,
        text: [
            ``
        ]
    },
    {
        header:`SETTINGS`,
        text: [
            ``
        ]
    },
    {
        header:`MISCELLANEOUS`,
        text: [
            ``
        ]
    },
]
